import BasicValidation from 'components/components/common/BasicValidation';
import TransHelper from 'components/common/translations/TransHelper';

export default class FirstStepValidation extends BasicValidation {
  constructor(props) {
    super();
    this.props = props;
  }

  isDateValid() {
    return this.props.startDate.value !== null;
  }

  isAirportValid() {
    return this.props.airportFrom.id || this.props.airportTo.id;
  }

  isAirportFromValid() {
    return this.props.airportFrom.label && this.props.airportFrom.label !== '';
  }

  isAirportToValid() {
    return this.props.airportTo.label && this.props.airportTo.label !== '';
  }

  isNumberOfPassengersValid() {
    return this.props.adultsNumber > 0 || this.props.childrenNumber > 0 || this.props.studentsNumber > 0;
  }

  isValidForm() {
    return this.isDateValid() &&
      (this.arePlacesValid() === true) &&
      this.isNumberOfPassengersValid() &&
      this.isAirportFromValid() &&
      this.isAirportToValid();
  }

  trans(key) {
    return TransHelper.translate(this.props.locale, key);
  }

  arePlacesValid() {
    const { airportFrom, airportTo } = this.props;
    // check if both are the same

    if (airportFrom.id && airportTo.id) {
      var sameId = airportFrom.id === airportTo.id;
      var bothAreAirports = airportFrom.isAirport && airportTo.isAirport;
      var bothAreCities = !airportFrom.isAirport && !airportTo.isAirport;
      if (sameId && (bothAreAirports || bothAreCities)) {
        return this.trans('content.bookingStep1.errors.location_same');
      }

      // check if both are airports
      if (airportFrom.isAirport && airportTo.isAirport) {
        return this.trans('content.bookingStep1.errors.two_airports');

      }

      // check if both are cities
      if (!airportFrom.isAirport && !airportTo.isAirport) {
        return this.trans('content.bookingStep1.errors.two_cities');
      }
      return true;
    }

  }

  getFieldsErrors() {
    var hash = {};

    var placesValid = this.arePlacesValid();
    if (placesValid !== true) {
      hash['places'] = placesValid;
    }

    if (!this.isDateValid()) {
      hash['date'] = this.trans('content.bookingStep1.errors.date');
    }

    if (!this.isAirportFromValid()) {
      hash['airportFrom'] = this.trans('content.bookingStep1.errors.place');
    }

    if (!this.isNumberOfPassengersValid()) {
      hash['passengers'] = this.trans('content.bookingStep1.errors.passengers');
    }

    if (!this.isAirportToValid()) {
      hash['airportTo'] = this.trans('content.bookingStep1.errors.place');
    }

    return hash;
  }

}
